import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'ODtnfV',
    description: 'Title for unsupported rule banner',
    defaultMessage: 'Rule not supported',
  },
  description: {
    id: '1g6LqA',
    description: 'Description for unsupported rule banner when rule has Carrier insurance',
    defaultMessage:
      'This rule contains the action type "Insure the Package" with "Carrier" insurance that is no longer supported. Remove or revise the unsupported actions to reactivate.',
  },
});

export default messages;
